import React, { useRef } from "react";

import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useState } from "react";
import {
  setTheQuerySubQuestionsEditionsActions,
  setTheQuerySubQuestionsRetrieveActions,
  setTheQuerySubQuestionsCreateActions,
} from "../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const SubQueryActions = (props) => {
  const { setShow, show, currentPage, EditID, ParentId , search } = props;
  console.log(EditID, "EditID", ParentId);
  const dispatch = useDispatch();

  const [ErrorInde, setErrInde] = useState(0);
  const state = useSelector((state) => state);
  const Headers = {
    name: "",
    description: "",
    parent_id: state.NeededdatasListed.SubQueryIDs,
    expire_time: "",
  };
  const [Data, setDatas] = useState(Headers);
  const [queryError, setqueryErr] = useState("");
  const [descriptionsErr, setDestionErr] = useState("");
  const [ExpireErr, setExpireErr] = useState("");
 const inputRef = useRef()
console.log(ExpireErr , "ExpireErr" , EditID);
  let currentDate = new Date();
  let year = currentDate.getFullYear();

  // Calculate the end of the current year
  let endOfYear = new Date(year, 11, 31); // December is 11th month (zero-based index)

  // Format the current date and end of year
  let currentMonth =
    (currentDate.getMonth() + 1 < 10 ? "0" : "") + (currentDate.getMonth() + 1);
  let currentDay =
    (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate();
  let formattedDate = `${year}-${currentMonth}-${currentDay}`;

  let endOfYearMonth =
    (endOfYear.getMonth() + 1 < 10 ? "0" : "") + (endOfYear.getMonth() + 1);
  let endOfYearDay =
    (endOfYear.getDate() < 10 ? "0" : "") + endOfYear.getDate();
  let formattedEndOfYear = `${year}-12-31`;

  useEffect(() => {
    if (EditID != undefined && EditID != "") {
      const payload = {
        EditID: EditID,
      };
      dispatch(setTheQuerySubQuestionsRetrieveActions(payload));
    }
  }, []);

  useEffect(() => {
    if (
      // EditID != ""

      EditID != undefined &&
      EditID != ""

      // &&
      // state.QuerySubQuestionsRetrieve.QuerySubQuestionRetrieve.id
    ) {
      setDatas({
        name: state.QuerySubQuestionsRetrieve.QuerySubQuestionRetrieve.name,
        description:
          state.QuerySubQuestionsRetrieve.QuerySubQuestionRetrieve.description,
        expire_time:
          state.QuerySubQuestionsRetrieve.QuerySubQuestionRetrieve.expire_time,
      });
    }
  }, [state.QuerySubQuestionsRetrieve.QuerySubQuestionRetrieve, EditID]);

  const HandleChanges = (e) => {
    if (e.target.name == "expire_time") {
      const { name, value } = e.target;

      setDatas((pre) => {
        return {
          ...pre,
          [name]:value,
        };
      });
    } else {
      const { name, value } = e.target;

      setDatas((pre) => {
        return {
          ...pre,
          [name]: value,
        };
      });
    }
  };

  const HandleSubmits = (e) => {
    // e.preventDefault();
  };

  const HandleSubmit = (e) => {
    var a = 0;




    if (EditID == undefined || EditID == "") {

      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Subcategory is required");
        a = 1;
      }

      if (Data.expire_time =='') {
        a = 1;

        setExpireErr("*Expire Date is required");
      }


      if (a == 0 && ErrorInde == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          parent_id: state.NeededdatasListed.SubQueryIDs,
          search:search
        };

        dispatch(setTheQuerySubQuestionsCreateActions(payload, setShow(false)));
      }
    } else if (EditID != undefined || EditID != "") {
      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Subcategory is required");
        a = 1;
      }

      if (Data.expire_time == "") {
        a = 1;

        setExpireErr("* Expire Date is required");
      }



      if (a == 0 && ErrorInde == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          EditID: EditID,
          parent_id: state.NeededdatasListed.SubQueryIDs,
          search:search

        };

        dispatch(
          setTheQuerySubQuestionsEditionsActions(payload, setShow(false))
        );
      }
    }
  };

  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
      event.preventDefault();
    }
  
    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData('text');
    
    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, '');
    
    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();
    
      event.target.value = filtered;
      HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
    
  };
  
  
  

  const preventwheel = (event) => {
    if (event.target&& event.target.className == "form-control"|| event.target.class =="form-control") {
    event.preventDefault();
    }
  }


 
  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {

      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (event.target&& event.target.className == "form-control"|| event.target.class =="form-control") {
        event.preventDefault();
      }
    };
    if (inputElement) {

      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  
  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "30%" }}>
            <div className="asds">
              <div class="ModalHeader">
                {EditID != undefined && EditID != "" ? (
                  <span className="UserCreate"> Ticket Subcategory </span>
                ) : (
                  <span className="UserCreate"> Ticket Subcategory </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
              <form class="row g-3 form-fields-wrapper" onClick={HandleSubmits}>
                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                     Subcategory
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.name}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setqueryErr("");
                    }}
                    required
                    name="name"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{queryError}</p>
                </div>

                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Expire Dates
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                               step="1"
                               type="number"
                   class="form-control"
                    value={Data.expire_time}
                    name="expire_time"

                    autoComplete="off"
                    onChange={(e) => {
                      if (e.target.value > 28) {
                        setExpireErr(
                          "Expiration date should not exceed 28 digits."
                        );
                        setErrInde(1)
                      } else {
                        setExpireErr("");
                      HandleChanges(e);
                        setErrInde(0)
                      }
                    }}
                    required
                    onKeyDown={(evt) => {
                      preventZoom(evt)

                     }}
                     onPaste={(evt) => handlePaste(evt)} // Handle pasting
                     onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel

                     ref={inputRef}

        ></input>
                <p style={{ color: "red", marginTop: "5px" }}>{ExpireErr}</p>

                </div>


                <div className="col-12 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Description
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.description}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setDestionErr("");
                    }}
                    required
                    name="description"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {descriptionsErr}
                  </p>
                </div>
              </form>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
                    //   HandleEdits(e);
                  }}
                >
                  Submit
                </button>
                <button
                  class="btn CancelBtn"
                  //  onClick={handleClose}
                  onClick={(e) => setShow(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubQueryActions;
